import { useMemo } from 'react'
import { sanitizeLineItemHtml } from '@/lib/sanitize-html'

interface SafeHtmlProps {
  html: string
  className?: string
}

const LIST_STYLES = `
  .safe-html ul { list-style-type: disc; margin-left: 1.25rem; margin-top: 0.25rem; margin-bottom: 0.25rem; }
  .safe-html ol { list-style-type: decimal; margin-left: 1.25rem; margin-top: 0.25rem; margin-bottom: 0.25rem; }
  .safe-html li { margin-top: 0.125rem; margin-bottom: 0.125rem; }
  .safe-html p { margin: 0; }
  .safe-html p + p { margin-top: 0.25rem; }
  .safe-html p + ul, .safe-html p + ol { margin-top: 0.25rem; }
`

export function SafeHtml({ html, className }: SafeHtmlProps) {
  const sanitized = useMemo(() => sanitizeLineItemHtml(html), [html])
  return (
    <>
      <style>{LIST_STYLES}</style>
      <div
        className={className ? `safe-html ${className}` : 'safe-html'}
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    </>
  )
}
